
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/Select.html",
      function () {
        return require("private-next-pages/Forms/Select.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/Select.html"])
      });
    }
  